var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.501 32.5392C22.501 31.7112 23.173 31.0272 24.001 31.0272C24.829 31.0272 25.501 31.6892 25.501 32.5172V32.5392C25.501 33.3672 24.829 34.0392 24.001 34.0392C23.173 34.0392 22.501 33.3672 22.501 32.5392Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59168 40.8358H38.5557C40.8497 40.7158 42.6137 38.7618 42.4957 36.4678C42.4697 36.0038 42.3697 35.5458 42.1937 35.1178L27.6397 9.6458C26.5277 7.6358 23.9977 6.9078 21.9877 8.0218C21.3037 8.3978 20.7397 8.9618 20.3617 9.6458L5.80768 35.1178C4.94368 37.2458 5.96768 39.6698 8.09368 40.5358C8.52568 40.7098 8.98168 40.8098 9.44568 40.8358",
    stroke: "#252525",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9805 26.7922V20.5922",
    stroke: "#252525",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.a713ca8752dc53fb52f84490e49aabe3.svg";
export { ForwardRef as ReactComponent };